<template>
  <div class="news_item_list">
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        @click="goToDetail(item, index)"
      >
        <!-- <div class="img">
          <img :src="item.cover ||  (item.covers && item.covers.split(',')[0])"  alt="" />
        </div> -->
        <div class="news_item_info">
          <p class="news_item_title">
            {{ item.projectName }}
          </p>
          <div style="height:54px"></div>
          <!-- <div class="news_item_desc">
            {{ item.description || item.des }}
          </div> -->
          <p class="news_item_data">
            <!-- <span
              >发布时间：{{
               item.readCount
                  ? item.readCount
                  : 0 || item.visitcount
                  ? item.visitcount
                  : 0
              }}</span> -->
              <span
              >发布时间：
              <!-- {{ item.releaseTime }} -->
              <!-- {{formateTime(item.releaseTime)}} -->
              {{formateTime(item.releaseTime)}}
              </span>
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { dateFormat } from '../utils';
export default {
  inject: ["urlType"],
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    formateTime(data){
      let date = new Date(data)
      return dateFormat(date,'YYYY-MM-dd')
    },
    goToDetail(item, index) {
      let routeUrl = this.$router.resolve({
        path: `/${this.urlType}`,
        query: {
          id: item.id,
        },
      });
      window.open(routeUrl.href,'_blank')
    },
  },
};
</script>

<style scoped lang="less">
.news_item_list {
  ul {
    li {
      // max-width: 757px;
      width: 100%;
      transition: all 0.5s;
      cursor: pointer;
      height: 140px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f8f8f8;
      padding: 15px;
      &:hover {
        box-shadow: 0 0 20px #ddd;
      }
      .img {
        width: 280px;
        height: 100%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.5s;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
      .news_item_info {
        display: flex;
        flex-direction: column;
        width: 60%;
        height: 100%;
        margin-left: 15px;
        .news_item_title {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          // 单行溢出省略
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
		  width: 98%;
        }
        // .news_item_desc {
        //   font-size: 14px;
        //   font-family: Microsoft YaHei;
        //   font-weight: 400;
        //   color: #666666;
        //   // 多行溢出省略
        //   display: -webkit-box;
        //   -webkit-box-orient: vertical;
        //   -webkit-line-clamp: 3;
        //   overflow: hidden;
        //   margin: 15px 0;
        //   height: 57px;
        // }
        .news_item_data {
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #9a9a9a;
            &:nth-of-type(2) {
              margin: 0 40px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projectList.vue